module.exports = __webpack_public_path__ + "static/michael2-326534c74fc9f46714075bb5e2702ca0.png";